import { createFileRoute } from "@tanstack/react-router";
import { useSuspenseQuery } from "@tanstack/react-query";
import { suspenseOptions } from "@/lib/suspense-query";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import InventoryForm from "../-form";
import { Header } from "@/components/universal/header";
import { getGetInventoryQueryOptions } from "@/requests/gen/react-query/inventory";

export const Route = createFileRoute(
  "/_private/_inventory-360/inventory/$inventoryId/edit",
)({
  loader: ({ context: { queryClient }, params: { inventoryId } }) =>
    queryClient.ensureQueryData(getGetInventoryQueryOptions(inventoryId)),
  component: InventoryEditPage,
});

function InventoryEditPage() {
  const { inventoryId } = Route.useParams();
  const { data: inventory } = useSuspenseQuery(
    suspenseOptions(getGetInventoryQueryOptions(inventoryId)),
  );

  return (
    <div>
      <title>
        {`Edit ${inventory?.product.display_name ?? "Inventory"} - Legrande Health Portal`}
      </title>
      <Header
        crumbs={[
          { name: "Inventory", link: { to: "/inventory/lookup" } },
          {
            name: inventory?.product.display_name ?? "Product Inventory",
            link: { to: "/inventory/$inventoryId", params: { inventoryId } },
          },
          {
            name: "Edit",
            link: {
              to: "/inventory/$inventoryId/edit",
              params: { inventoryId },
            },
          },
        ]}
      />
      <Card>
        <CardHeader>
          <CardTitle>Edit Inventory Settings</CardTitle>
          <CardDescription>
            Update the 90 day supply for this product.
          </CardDescription>
        </CardHeader>
        <CardContent>
          {inventory && <InventoryForm inventory={inventory} />}
        </CardContent>
      </Card>
    </div>
  );
}
